import { getWindow, storageFactory } from './utils';
export var sessionStorageStrategy = storageFactory('sessionStorageStrategy', function () { var _a; return (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage; });
